<template>
  <v-btn :id="id" small :color="color ? color : 'primary'" text v-on="$listeners">
    <v-icon left v-if="type === 'plus'"> mdi-plus-circle-outline </v-icon>
    <span class="text-capitalize text-body-2">
      {{ buttonText }}
    </span>
    <v-icon right v-if="type !== 'plus'"> mdi-close-circle-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'FmButton',
  props: {
    buttonText: {
      type: String,
      default: () => 'label'
    },
    color: {
      type: String,
      default: () => undefined
    },
    type: {
      type: String,
      default: () => 'plus'
    },
    id: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style scoped></style>
